import { PAYMENT_TYPES, PAYMENT_MODES, PAYMENT_OFFSET_TYPES, PAYMENT_BATCH_TYPE } from '../data/payment.data';
import { EPaymentAction, EPaymentMemoType, EPaymentRecordType, EPaymentStatus } from '../enums/payment.enum';

export type PaymentDisabledFields = 'taxable' | 'description' | 'advance';

export type PaymentType = typeof PAYMENT_TYPES[number]['id'];
export type PaymentMode = typeof PAYMENT_MODES[number]['id'];
export type PaymentBatchType = typeof PAYMENT_BATCH_TYPE[number]['id'];
export type PaymentOffsetType = typeof PAYMENT_OFFSET_TYPES[number]['id'];

export type PaymentStatus = `${EPaymentStatus}`;
export type PaymentMemoType = `${EPaymentMemoType}`;
export type PaymentActionType = `${EPaymentAction}`;
export type PaymentRecordType = `${EPaymentRecordType}`;

export type PaymentNavigationDescriptionType<T> = {
  id: T;
  title: string;
  linkPrefix: string | null;
};

export type PaymentNavigationTypeRecord = Record<PaymentRecordType, PaymentNavigationDescriptionType<PaymentRecordType>>;
export type PaymentOffsetNavigationTypeRecord = Record<PaymentOffsetType, PaymentNavigationDescriptionType<PaymentOffsetType>>;
